import '@/app/app.css';
import './help.css';

import '@/app/app';
import { VideoModal } from '@/shared/common/video/video-modal';

document.addEventListener('DOMContentLoaded', () => {
	new VideoModal('modal-card-video');
});
